import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Link } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Colors } from './StoreRating/Star.js';
import { Stars } from './StoreRating/Stars.js';

var StoreRating = (_param)=>{
    var { className , labels , rating , urls , onClickReview  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "rating",
        "urls",
        "onClickReview"
    ]);
     return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-rating', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: "store-rating__title",
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement(Stars, {
        color: Colors.gold,
        className: "store-rating__stars",
        rating: rating,
        "aria-hidden": true
    }), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating",
        variant: "body"
    }, labels.rating), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating-count",
        variant: "body"
    }, labels.ratingCount), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__description",
        variant: "body"
    }, labels.description), (urls === null || urls === void 0 ? void 0 : urls.review) && /*#__PURE__*/ React.createElement(Link, {
        className: "store-rating__review",
        url: urls.review,
        target: "_blank",
        onClick: onClickReview
    }, labels.review));
};

export { StoreRating, StoreRating as default };
//# sourceMappingURL=StoreRating.js.map
